





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import Localization from '@/service/localization'

@Component({
  name: 'c-edit-project-dialog'
})
export default class EditProjectDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Object) project!: any

  title: string = ''
  description: string = ''

  get show (): boolean {
    return this.value
  }
  set show (value: boolean) {
    this.$emit('input', value)
  }

  @Watch('project')
  isProjectChanged () {
    this.title = this.project.title
    this.description = this.project.description
  }

  cancel (): void {
    this.show = false
  }

  send (): void {
    Localization.editProject({
      _id: this.project._id,
      description: this.description,
      title: this.title
    }).then(res => {
      if (res == true) {
        this.$emit('update-projects')
      }
    })
    this.show = false
  }
}
